import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlloyService } from 'src/app/shared/alloy/alloy.service';
import { LoginService } from 'src/app/shared/user-login/login.service';
import { DatePipe } from '@angular/common';
import {TooltipPosition} from '@angular/material/tooltip';

@Component({
    selector: 'app-get-alloys',
    templateUrl: './get-alloys.component.html',
    styleUrls: ['./get-alloys.component.css'],
    standalone: false
})
export class GetAlloysComponent implements OnInit {
  allalloys
  origAlloys
  alloys
  role: string;

  serverErrorMessages: string
  loading:boolean=true
  startDate;
  iron1
  iron2
  // , [Validators.required]
  grade
  drp_grade1=[]
  gIron = ['Grey Iron','Ductile Iron']
  ironType = ['Base Iron','Final Iron']
  endDate;
  filterForm = new FormGroup({
    startDate: new FormControl(''),
    endDate: new FormControl(''),
    iron1: new FormControl(''),
    iron2: new FormControl(''),
    grade: new FormControl(''),
  })
  position = 'above'
  missingFields = false

  constructor(private loginService: LoginService, private alloyService: AlloyService, private router : Router, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.endDate = this.transformDate(new Date());
    if (this.loginService.shouldBlock()) {
      alert('Low Balance! Redirecting...');
      this.router.navigateByUrl('/home');
    }
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          // this.loading = false;
          this.getAllAlloys();
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          // this.loading = false;
        }
      )

    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  getAllAlloys(){
    this.alloyService.getAlloy().subscribe(
      res => {
        this.allalloys = res['alloyDatas'];

        for (var x of this.allalloys) {
          if (x.greyIron.baseIron) {
            x.iron1="Grey Iron";
            x.iron2="Base Iron";
            this.drp_grade1.push(x.grade)
          }
          else if (x.greyIron.finalIron) {
            x.iron1="Grey Iron";
            x.iron2="Final Iron";
          }
          else if (x.ductileIron.baseIron) {
            x.iron1="Ductile Iron";
            x.iron2="Base Iron";
            this.drp_grade1.push(x.grade)
          }
          else if (x.ductileIron.finalIron) {
            x.iron1="Ductile Iron";
            x.iron2="Final Iron";
          }
        }

        this.alloys = this.allalloys;
        // console.log(this.alloys)
        this.alloys = this.alloys.reverse();

        console.log(this.alloys)
       //console.log('Got alloys', this.allalloys)
        this.loading=false;
      },
      err=>{
       //console.log('Error getting alloys', err);
        this.serverErrorMessages = err.error.message
      }
    )
  }

  editAlloy(alloy){
    this.alloyService.changeAlloy(alloy);
    this.router.navigateByUrl('/edit-alloys')
  }

  copyAlloy(alloy){
    this.alloyService.changeAlloy(alloy);
    this.router.navigateByUrl('/alloy')
  }

  deleteAlloy(alloy){
    if(window.confirm('Are you sure want to delete the alloy?')){
    this.alloyService.deleteAlloy({alloyId: alloy['_id']}).subscribe(
      res=>{
       //console.log('delete success', res);
        window.location.reload()
      },
      err => {
       //console.log('error', err)
      }
    )
    }
  }

  filter(){
    this.startDate=this.transformDate(this.filterForm.get('startDate').value)
    this.endDate=this.transformDate(this.filterForm.get('endDate').value)
    this.iron1=this.filterForm.get('iron1').value
    this.iron2=this.filterForm.get('iron2').value
    this.grade = this.filterForm.get('grade').value
    // !this.startDate || !this.endDate ||
    if ( !this.iron1 && !this.iron2 && !this.grade)
    {
      alert("please enter values for at least one field to filter!");
    }
    else
    {
      this.missingFields=false
      // console.log(this.startDate, this.endDate)
      this.alloys = []
      for (var x of this.allalloys) {
        var i1
        var i2
        var gr = x.grade
        // console.log(gr)
        if (x.greyIron.baseIron==true) {
          i1="Grey Iron";
          i2="Base Iron";
        }
        else if (x.greyIron.finalIron==true) {
          i1="Grey Iron";
          i2="Final Iron";
        }
        else if (x.ductileIron.baseIron==true) {
          i1="Ductile Iron";
          i2="Base Iron";
        }
        else if (x.ductileIron.finalIron==true) {
          i1="Ductile Iron";
          i2="Final Iron";
        }

        var d = this.transformDate(x.createdAt)

        if(this.iron1)  //iron 1 has been entered
        {
            if(this.iron2) //iron 2 has been entered
            {
              if(this.grade)  //iron1 && iron2 && grade
              {
                if (i1==this.iron1 && i2==this.iron2 && gr.toLowerCase().indexOf(this.grade.toLowerCase()) > -1)
                {
                  console.log(x);
                  this.alloys.push(x)
                }
              }

              else // only iron1 && iron2
              {
                if(i1==this.iron1 && i2==this.iron2)
                {
                  console.log(x);
                  this.alloys.push(x)
                }
              }
            }

            else   // iron 2 is blank
            {
              if(this.grade)  // iron 1 && grade
              {
                if(i1==this.iron1 && gr.toLowerCase().indexOf(this.grade.toLowerCase()) > -1)
                {
                  console.log(x);
                  this.alloys.push(x)
                }
              }
              else   //only iron 1
              {
                if(i1==this.iron1)
                {
                  console.log(x);
                  this.alloys.push(x)
                }
              }
            }

        }

        else if(this.iron2)  //iron 1 is blank
        {
            if(this.grade)  //iron2 && grade
            {
              if (i2==this.iron2 && gr.toLowerCase().indexOf(this.grade.toLowerCase()) > -1)
              {
                console.log(x);
                this.alloys.push(x)
              }
            }
            else // only iron2
            {
              if(i2==this.iron2)
              {
                console.log(x);
                this.alloys.push(x)
              }
            }
        }

        else if (this.grade)
        {
          if (gr.toLowerCase().indexOf(this.grade.toLowerCase()) > -1)
              {
                console.log(x);
                this.alloys.push(x)
              }
        }


        // else if (i2==this.iron2 && !this.iron1 && !this.grade || i2==this.iron2 && this.iron1.length==0 && this.grade.length==0)
        // {
        //   console.log(x);
        //   this.alloys.push(x)
        // }
        // else if(gr.toLowerCase().indexOf(this.grade.toLowerCase()) > -1 && !this.iron2 && !this.iron1 || gr.toLowerCase().indexOf(this.grade.toLowerCase()) > -1 && this.iron2.length==0 && this.iron1.length==0)
        // {
        //   console.log(x);
        //   this.alloys.push(x)
        // }

      }
      console.log("New alloys", this.alloys)

    }

  }

  reset(){
    this.filterForm.reset()
    this.missingFields=false
    this.alloys=this.allalloys;
  }

  transformDate(x){
    return(this.datePipe.transform(x, 'yyyy-MM-dd'));
  }

}
